import { render, staticRenderFns } from "./companyVideo.vue?vue&type=template&id=693873ed&scoped=true"
import script from "./companyVideo.vue?vue&type=script&lang=js"
export * from "./companyVideo.vue?vue&type=script&lang=js"
import style0 from "./companyVideo.vue?vue&type=style&index=0&id=693873ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693873ed",
  null
  
)

export default component.exports